// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/scss/theme/orange.scss
// module id = 2104
// module chunks = 50